<template>
  <div class="file-input">
    <label class="file-label">
        <span class="file-cta">
        <span class="file-icon">
          <i class="fas fa-upload"></i>
        </span>
        <span class="file-label">
          {{ label }}
        </span>
      </span>
      <input type="file" ref="input" @change="handleFileChange" :accept="accept">
    </label>
  </div>
</template>

<script>
export default {
  name: 'InputFoto',
  props: {
    accept: { type: String, default: 'image/jpeg' },
    label: { type: String, default: 'Escolha a imagem' }
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result;
          this.$emit('foto-selecionada', base64Data);
        };
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>